<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Fields from "@/helpers/fields";
import moment from "moment";
import { todoMethods, todoComputed } from "@/state/helpers";
import { tableData } from "../dataAdvancedtable";
import axios from "axios";
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Negocios",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  filters: {
    moment: function (date) {
      return moment(date).format("LL");
    },
  },
  data() {
    return {
      // ************************************** Link
      tableData: tableData,
      title: "Negocios",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Negocios",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      tableBusiness: [],
      negociosFields: Fields.negociosFields,
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {
    this.getTable();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableBusiness.length;

    this.todoTotalRows = this.tableBusiness.length;

    document.getElementById("b_table_business").firstElementChild.classList.add("table-light");
  },

  methods: {
    getTable() {
      axios.get("/negocios")
        .then((response) => {
          this.response = response.data.data;
          this.tableBusiness = response.data.data;
          this.totalRows = response.data.data.length;
        });
    },
    ...todoMethods,

    handleEdit(id_negocio){
      this.$router.push({
        name:'ActualizaNegocios',
        params:{
          id_negocio
        }
      })
    },

    toSucursal(id_negocio){
      console.log('aqui');
      this.$router.push({
        name:'sucursales',
        params:{
          id_negocio
        }
      })
    },

    handleDelete(id_negocio) {
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put("/negocios", { id_negocio, active: "0" })
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Eliminado",
                  "Negocio eliminado correctamente",
                  "success"
                );
                this.$router.push({ name: "Negocios" });
                this.getTable();
              } else {
                this.$swal("Alertas", "No se pudo eliminar", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        }
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title mb-4">Registro de empresas</h4>
              </div>
              <div class="col-sm-12 col-md-6 text-md-end">
                <router-link to="/NuevoNegocio">
                  <v-btn
                    depressed
                    color="primary"
                    type="button"
                    id="button-addon2"
                  >
                    Nuevo registro
                  </v-btn>
                </router-link>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset vertical></v-divider>

                    registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- tableBusiness table -->
            <b-table
              id="b_table_business"
              class="table-centered"
              :fields="negociosFields"
              :items="tableBusiness"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template #cell(id_negocio)="data">
                <a href="javascript: void(0);" class="text-body fw-bold">
                  {{ data.item.id_negocio }}
                </a>
              </template>
              <template #cell(logotipo)="data">
                <img
                  :src="data.item.logotipo"
                  class="rounded-circle header-profile-user"
                  style="object-fit: cover"
                  alt="Sheep"
                />
              </template>
              <template #cell(fecha)="data">
                {{ data.item.fecha | moment }}
              </template>
              <template #cell(estatus)="data">
                <span
                  class="badge badge-pill bg-success font-size-11"
                  :class="{
                    'bg-warning': `${data.item.estatus}` === '0',
                    'bg-success': `${data.item.estatus}` === '1',
                  }"
                  >{{ data.item.estatus === 1 ? "Activo" : "Desactivo" }}</span
                >
              </template>
              <template #cell(edit)="data">
                <v-btn
                  icon
                  small
                  @click="handleEdit(data.item.id_negocio)"
                >
                  <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="toSucursal(data.id_negocio)"
                >
                  <i style="color: #60277d" class="bx bx-store-alt"></i>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="handleDelete(data.item.id_negocio)"
                >
                  <i style="color: #e73484" class="bx bx-trash"></i>
                </v-btn>
              </template>
            </b-table>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <v-divider class="mx-2" inset vertical></v-divider>
              Mostrando {{ perPage > tableBusiness.length ? tableBusiness.length : perPage }} de {{ tableBusiness.length }} registros
            </div>
            <div class="col-sm-12 col-md-6 text-md-end pr-10">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="tableBusiness.length"
                :per-page="perPage"
                first-text="Primera"
                prev-text="Anterior"
                next-text="Siguiente"
                last-text="Última"
              ></b-pagination>
            </div>
          </div>
        </v-card>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
